/**
 * Status of a ProvisionContractAgent (R-08). SUSPENDED = active but contribution-free
 * ("beitragsfrei"): the amortisation pauses, the reversal already booked stays booked (P-06,
 * U-02). Allowed transitions: ACTIVE<->SUSPENDED; ACTIVE/SUSPENDED->CANCELLED; CANCELLED->ACTIVE
 * (Storno-Ruecknahme, D-16); ACTIVE->EXPIRED (Ablauf).
 *
 * Position-based mirror of the backend enum {@code com.mvs.backend.cp.enums.ProvisionLiabilityStatus}. The backend
 * persists the ordinal (`@Enumerated(EnumType.ORDINAL)`), so the declaration order below MUST match
 * the backend exactly and new constants MUST only be appended at the end — never inserted between
 * existing ones, which would silently re-map every stored value (02-datenmodell.md §0.5/§2).
 */
export enum ProvisionLiabilityStatus {

    ACTIVE,
    EXPIRED,
    CANCELLED,
    SUSPENDED
}
